// @ts-nocheck

import React, { useState, useContext, createContext, useEffect } from 'react';
import { useCollection } from '@cloudscape-design/collection-hooks';
import {
  Box,
  Button,
  CollectionPreferences,
  Header,
  Pagination,
  Table,
  TextFilter,
  Grid,
  Link,
  SpaceBetween,
  FormField,
  Input,
  StatusIndicator,
  Checkbox,
  Form,
  Popover,
  Autosuggest,
  Modal,
  Textarea,
} from '@cloudscape-design/components';
import { columnDefinitions, getMatchesCountText, paginationLabels, collectionPreferencesProps } from './table-config';
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import DatePicker from '../../components/date-picker/DatePicker';
import PhoneInput, { isPossiblePhoneNumber } from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags'



// Create Modal context API
const ModalContext = createContext();
const { Provider } = ModalContext;


function EmptyState({ title, subtitle, action }) {
  return (
    <Box textAlign="center" color="inherit">
      <Box variant="strong" textAlign="center" color="inherit">
        {title}
      </Box>
      <Box variant="p" padding={{ bottom: 's' }} color="inherit">
        {subtitle}
      </Box>
      {action}
    </Box>
  );
}


export default function DriverTable( tableItems, visibleColumns, tableLoading ) {
  const [preferences, setPreferences] = useState({ pageSize: 20, visibleContent: visibleColumns });
  const [ modalVisible, setModalVisible ] = useState(false);
  const [ modalContent, setModalContent ] = useState();
  const { items, actions, filteredItemsCount, collectionProps, filterProps, paginationProps } = useCollection(
    tableItems,
    {
      filtering: {
        empty: <EmptyState title="No drivers" />,
        noMatch: (
          <EmptyState
            title="No drivers"
            action={<Button onClick={() => actions.setFiltering('')}>Clear filter</Button>}
          />
        ),
      },
      pagination: { pageSize: preferences.pageSize },
      sorting: {},
      selection: {},
    }
  );
  const { selectedItems } = collectionProps;


  const contextValue = {
    modalVisible,
    setModalVisible,
  }


  return (
    <>
      <Provider value={contextValue}>
        <DriverProfileModal driverProfile={modalContent} />

        <div style={{display: "flex", width: "100%", justifyContent: "flex-end", fontSize: "1.1rem", fontWeight: "bold", color: "darkgray"}}>
          {`${tableItems.length} Drivers`}
        </div>
        <Table
          // className="driver-table"
          data-table
          trackBy="driverId"
          variant="embedded"
          loading={tableLoading}
          loadingText="Loading drivers"
          resizableColumns
          stickyHeader
          {...collectionProps}
          // selectionType="multi"
          onRowClick={({ detail }) => {
            // console.table(detail.item)
            setModalContent(detail.item)
            setModalVisible(true)
          }}
          header={
            <Header
              // counter={selectedItems.length ? `(${selectedItems.length}/${tableItems.length})` : `(${tableItems.length})`}
            >
              {/* {tableName} */}
            </Header>
          }
          columnDefinitions={columnDefinitions}
          visibleColumns={preferences.visibleContent}
          items={items}
          pagination={<Pagination {...paginationProps} ariaLabels={paginationLabels}/>}
          filter={
            <TextFilter
              {...filterProps}
              countText={getMatchesCountText(filteredItemsCount)}
              filteringAriaLabel="Filter instances"
              filteringPlaceholder='Enter a value to filter driver records...'
            />
          }
          preferences={
            <CollectionPreferences
              {...collectionPreferencesProps}
              preferences={preferences}
              onConfirm={({ detail }) => setPreferences(detail)}
            />
          }
        />
      </Provider>
    </>
  );
}




const DriverProfileModal = (props:any) => {
  const { modalVisible, setModalVisible } = useContext(ModalContext);
  const { driverProfile } = props;

  const [ email, setEmail ] = useState<string>();
  const [ givenName, setGivenName ] = useState<string>();
  const [ familyName, setFamilyName ] = useState<string>();
  const [ name, setName ] = useState<string>();
  const [ profilePicture, setProfilePicture ] = useState<string>();
  const [ dob, setDob ] = useState<string>();
  const [ address, setAddress ] = useState<string>();
  const [ driverId, setDriverId ] = useState<string>();
  const [ irUserId, setIrUserId ] = useState<string>();
  const [ irUserName, setIrUserName ] = useState<string>();
  const [ country, setCountry ] = useState<string>();
  const [ addressUrl, setAddressUrl ] = useState<string>();
  const [ state, setState ] = useState<string>();
  const [ postCode, setPostCode ] = useState<string>();
  const [ username, setUsername ] = useState();
  const [ phone, setPhone ] = useState<string>();
  const [ maLicenseId, setMaLicenseId ] = useState<string>();
  const [ discordId, setDiscordId ] = useState<string>();
  const [ carNum, setCarNum ] = useState<string>();
  const [ secondaryCarNum, setSecondaryCarNum ] = useState<string>();
  const [ tertiaryCarNum, setTertiaryCarNum ] = useState<string>();
  const [ driverBio, setDriverBio ] = useState<string>();
  const [ consentToShareInfo, setConsentToShareInfo] = useState<boolean>(true);
  const [ agreeToFrgRules, setAgreeToFrgRules] = useState<boolean>(false);
  const [ notifyEvents, setNotifyEvents ] = useState<boolean>(false);

  useEffect(() => {
    if (driverProfile !== undefined) {
      setUsername(driverProfile.username);
      setEmail(driverProfile.email);
      setGivenName(driverProfile.givenName);
      setFamilyName(driverProfile.familyName);
      setName(driverProfile.name);
      setProfilePicture(driverProfile.picture);
      setDob(driverProfile.dob);
      setPhone(driverProfile.phone);
      setAddress(driverProfile.address);
      setMaLicenseId(driverProfile.maLicenseId);
      setIrUserId(driverProfile.irUserId);
      setIrUserName(driverProfile.irUserName);
      setDiscordId(driverProfile.discordId);
      setCarNum(driverProfile.carNum);
      setSecondaryCarNum(driverProfile.secondaryCarNum);
      setTertiaryCarNum(driverProfile.tertiaryCarNum);
      setDriverBio(driverProfile.driverBio);
      if (driverProfile.consentToShareInfo) setConsentToShareInfo(driverProfile.consentToShareInfo);
      // if (driverProfile.agreeToFrgRules) setAgreeToFrgRules(driverProfile.agreeToFrgRules);
      if (driverProfile.notifyEvents) setNotifyEvents(driverProfile.notifyEvents);
    }
  }, [driverProfile]);


  return (
    <Modal
        onDismiss={() => setModalVisible(false)}
        visible={modalVisible}
        // footer={
        //   <Box float="right">
        //     <SpaceBetween direction="horizontal" size="xs">
        //       <Button variant="link" onClick={()=>{setModalVisible(false)}}>Cancel</Button>
        //       <Button variant="primary" onClick={()=>{setModalVisible(false)}}>Ok</Button>
        //     </SpaceBetween>
        //   </Box>
        // }
        header="Driver Profile"
      >
        <Form
          actions={
            <SpaceBetween direction="horizontal" size="xs">
              <Button 
                formAction="none" 
                variant="link"
                onClick={() => {
                  setModalVisible(false);
                }}
              >
                Cancel
              </Button>
                <Button 
                  variant="primary"
                  disabled
                  onClick={ () => {
                    // postLeagueDriver()
                    setModalVisible(false);
                  }}
                >
                  Update
                </Button>              
            </SpaceBetween>
          }
        >
          <div style={{
            display: "flex",
            fontSize: "28px",
            fontWeight: "bold",
            alignItems: "center",
            width: "100%",
            margin: "20px 0px 20px 0px",
          }}>
            Personal Info
          </div>
          <SpaceBetween size="xxl">
            <Grid
              gridDefinition={[
                { colspan: { default: 12, xs: 6, } },
                { colspan: { default: 12, xs: 6, } },
                { colspan: { default: 12, xs: 6, } },
                { colspan: { default: 12, xs: 6, } },
                { colspan: { default: 12, xs: 12, } },
                { colspan: { default: 12, xs: 7, } },
                { colspan: { default: 12, xs: 5, } },
                { colspan: { default: 12, xs: 12, } },
                { colspan: { default: 12, xs: 12, } },
              ]}
            >  
              <FormField label="Username" stretch >
                <Input
                  // onChange={({ detail }) => {setUsername(detail.value)}}
                  value={username ? username : ""}
                  disabled
                />
              </FormField>
              <FormField label="Email Address" stretch >
                <Input
                  onChange={({ detail }) => {setEmail(detail.value)}}
                  value={email ? email : ""}
                  type="email"
                  disabled
                />
              </FormField>
              <FormField label="First Name" stretch >
                <Input
                  onChange={({ detail }) => {setGivenName(detail.value.substring(0, 20))}}
                  value={givenName ? givenName : ""}
                  type="text"
                />
              </FormField>
              <FormField label="Last Name" stretch >
                <Input
                  onChange={({ detail }) => {setFamilyName(detail.value.substring(0, 20))}}
                  value={familyName ? familyName : ""}
                  type="text"
                />
              </FormField>
              <FormField 
                label="Address" 
                stretch 
                description="Address is intentionally hidden. Enter a new address if you would like to update the FRG records"
              >
                <Autosuggest
                  onSelect={ ( { detail } ) => {
                    setAddress(detail.selectedOption?.description!)
                    // getPlacePredictions({ input: detail.selectedOption?.description })
                  }}
                  onChange={ ( event ) => {
                    setAddress(event.detail.value.substring(0, 50));
                    // getPlacePredictions({ input: event.detail.value });
                  }}
                  disableBrowserAutocorrect
                  placeholder="Enter Address"
                  value={address ? address : ""}
                  // options={placePredictions.map((item) => (item))}
                  ariaLabel="Auto select address"
                  loadingText="Loading"
                  key={"autosuggest-address"}
                  // statusType={isPlacePredictionsLoading ? "loading" : "finished"}
                  enteredTextLabel={()=>{return ""}}
                />
              </FormField>
              <FormField label="Phone Number" stretch>
                <PhoneInput
                  placeholder="Enter phone number"
                  value={phone}
                  onChange={ ( event ) => {
                    setPhone(event!.substring(0, 20))
                  }}
                  flags={flags}
                  defaultCountry="AU"
                  addInternationalOption
                />
              </FormField>
              <FormField 
                label="Date of Birth"
                stretch
              >
                <DatePicker id="date-picker"
                  name='Date of birth'
                  onChange={ ( event ) => {
                    console.log(new Date(event.target.value).toLocaleDateString())
                    setDob(new Date(event.target.value).toLocaleDateString())
                  }}
                  placeholder={new Date(dob ? dob : "now").toLocaleDateString()}
                  value={new Date(dob ? dob : "now").toLocaleDateString()}
                />  
              </FormField>
              <FormField label="Profile Picture" stretch >
                <Input
                  onChange={({ detail }) => {setProfilePicture(detail.value.substring(0, 100))}}
                  value={profilePicture ? profilePicture : ""}
                  disabled
                  type="url"
                />
              </FormField>
              <FormField label="Driver Bio" stretch >
                <Textarea
                  onChange={({ detail }) => {setDriverBio(detail.value.substring(0, 200))}}
                  value={driverBio ? driverBio : ""}
                />
              </FormField>
            </Grid>
            <div style={{
              display: "flex",
              fontSize: "28px",
              fontWeight: "bold",
              alignItems: "center",
              width: "100%",
              margin: "20px 0px 20px 0px",
            }}>
              Additional Info
            </div>
            {/* <div style={{
              borderRadius: "8px",
              padding: "15px",
              background: "#c8cef7",
            }}> */}
              <Grid
                gridDefinition={[
                  { colspan: { default: 12, xs: 6, } },
                  { colspan: { default: 12, xs: 6, } },
                  // { colspan: { default: 12, xs: 4, } },
                ]}
              >
                <FormField label="iRacing User ID" stretch >
                  <Input
                    onChange={({ detail }) => {setIrUserId(detail.value)}}
                    value={irUserId ? irUserId : ""}
                    // disabled
                  />
                </FormField>
                <FormField label="iRacing Driver Name" stretch>
                  <Input
                    onChange={({ detail }) => {setIrUserName(detail.value)}}
                    value={irUserName ? irUserName : ""}
                    // disabled
                  />
                </FormField>
                {/* <div style={{
                  display: "flex",
                  height: "100%",
                  justifyContent: "center",
                  // paddingTop: "20px",
                }}>
                  <Button
                    variant="normal"
                    onClick={() => setIrDriverLookupModalVisible(true)}
                  >
                    iRacing Driver Lookup
                  </Button>
                </div> */}
              </Grid>
            {/* </div> */}
            <Grid
              gridDefinition={[
                { colspan: { default: 12, xs: 6, } },
                { colspan: { default: 12, xs: 6, } },
                { colspan: { default: 12, xs: 4, } },
                { colspan: { default: 12, xs: 4, } },
                { colspan: { default: 12, xs: 4, } },
              ]}
            >
              <FormField label="Discord User ID" stretch >
                <Input
                  onChange={({ detail }) => {setDiscordId(detail.value.substring(0, 30))}}
                  value={discordId ? discordId : ""}
                />
              </FormField>
              <FormField label="MA License ID" stretch>
                <Input
                  onChange={({ detail }) => {setMaLicenseId(detail.value.substring(0, 30))}}
                  value={maLicenseId ? maLicenseId : ""}
                />
              </FormField>
              <FormField label="Car # First Preference" >
                <Input
                  onChange={({ detail }) => {setCarNum(detail.value.substring(0, 3))}}
                  value={carNum ? carNum : ""}
                  type="number"
                />
              </FormField>
              <FormField label="Car # Second Preference" stretch >
                <Input
                  onChange={({ detail }) => {setSecondaryCarNum(detail.value.substring(0, 3))}}
                  value={secondaryCarNum ? secondaryCarNum : ""}
                  type="number"
                />
              </FormField>
              <FormField label="Car # Third Preference" stretch>
                <Input
                  onChange={({ detail }) => {setTertiaryCarNum(detail.value.substring(0, 3))}}
                  value={tertiaryCarNum ? tertiaryCarNum : ""}
                  type="number"
                />
              </FormField>
            </Grid>
            <Box>
              <Checkbox
                onChange={({ detail }) =>
                  setNotifyEvents(detail.checked)
                }
                checked={notifyEvents}
              >
                Notify me of new and upcoming FRG events
              </Checkbox>
              <Checkbox
                onChange={({ detail }) =>
                  setConsentToShareInfo(detail.checked)
                }
                checked={consentToShareInfo}
              >
                You consent to allow FRG to share your contact information with sponsors.
              </Checkbox>
              <Checkbox
                onChange={({ detail }) =>
                  setAgreeToFrgRules(detail.checked)
                }
                checked={agreeToFrgRules}
              >
                You have read and agree to the FRG privacy policy and FRG League Rules.
              </Checkbox>
            </Box>
          </SpaceBetween>
        </Form>
      </Modal>
  );
}